import styles from "./button.module.scss";
import cn from "classnames";
import { ButtonBaseProps, ButtonSize } from "./button.typer";
import useDebug from "../../hooks/useDebug";
import { track } from "../../api/tracking";

type IconLinkProps = ButtonBaseProps & {
  text: string;
  navigateTo: string;
};

export default function EksternLinkButton({
  buttonType = "primary",
  size = "large",
  text,
  icon,
  setIconLast = false,
  navigateTo,
  style,
  className,
  trackingName,
  ...rest
}: IconLinkProps) {
  const order = setIconLast ? styles.flipIconAndText : "";
  const iconSize = ButtonSize[size] === ButtonSize.small ? "small" : "medium";
  const displayedIcon = icon && <sds-icon name={`${icon}-material-outlined`} />;
  const debug = useDebug();
  const trackClickAndHandle = () => {
    track.userAction("Click EksternLink", trackingName);
  };

  return (
    <a
      href={navigateTo}
      className={cn(
        styles.iconLinkStructure,
        styles.iconLink,
        styles[buttonType],
        styles[size],
        iconSize,
        className,
        order,
        style ? style : "",
        debug ? styles.debugTooltip : "",
      )}
      onClick={trackClickAndHandle}
      {...rest}
      data-tracking-name={trackingName}
    >
      <span className={cn(styles.primaryText)}>
        {displayedIcon}
        <span>{text}</span>
      </span>
    </a>
  );
}
